<template>
  <div class="row">
    <div class="span8 list-main">
      <h3 class="list-title" style="font-size: 22px;">活动区</h3>
      <ul class="tabs-nav">
        <li :class="{ active: pagelistquery.lable === '' }" @click="changelable('')">全部</li>
        <li v-for="item in lables" :key="item" :class="{ active: pagelistquery.lable === item }" @click="changelable(item)">{{ item }}</li>
      </ul>
      <ul class="articles">
        <li class="article-entry" v-for="item in tableData" :key="item.activity_id">
          <h4 class="entry-title">
            <router-link :to="`/activitycontent/${item.activity_id}`">{{ item.activity_title }}</router-link>
          </h4>
          <div class="entry-meta">
            <span>🕐 {{ item.createtime | dataFormat }}</span>
            <span>📍 {{ item.activity_locale }}</span>
            <span>👁 {{ item.activity_read_num }}</span>
          </div>
        </li>
      </ul>
      <div class="pagination-wrap">
        <el-pagination
          layout="prev, pager, next"
          :total="pagelistquery.total"
          :page-size="10"
          @current-change="getlist"
        ></el-pagination>
      </div>
    </div>
    <div class="span4 page-sidebar">
      <carousel-widget />
      <job-widget />
    </div>
  </div>
</template>

<script>
import carouselWidget from '@/components/carousel.vue'
import jobWidget from '@/components/job.vue'
import { getActivityList, getLable } from '@/api'

export default {
  name: 'Activity',
  components: { carouselWidget, jobWidget },
  data() {
    return {
      lables: [],
      tableData: [],
      pagelistquery: { lable: '', page: 1, total: 0 }
    }
  },
  created() {
    getLable('活动分类').then((res) => {
      this.lables = JSON.parse(res.data[0].lable) || []
    })
    this.getlist(1)
  },
  methods: {
    getlist(page) {
      this.pagelistquery.page = page
      getActivityList({ ...this.pagelistquery, pagesize: 10 }).then((res) => {
        this.tableData = res.data || []
        this.pagelistquery.total = res.count || 0
      })
    },
    changelable(lable) {
      this.pagelistquery.lable = lable
      this.getlist(1)
    }
  }
}
</script>
